import React from 'react';
import { SubtractCircleIcons } from '../../../../icons/icons';
import { formatItemIndex } from '../functions';
import { JobTitleCardProps } from '../interfaces';

export const JobTitleCard = ({
  jobTitle,
  index,
  currentPage,
  itemsPerPage,
  onDelete,
}: JobTitleCardProps) => {
  return (
    <div className='flex items-center justify-between rounded-xl border border-gray-200/90 bg-white p-3.5 hover:border-gray-300 hover:shadow-md transition-all duration-200 group'>
      <div className='flex items-center gap-2.5 min-w-0 flex-1 mr-2'>
        <span className='text-[11px] text-gray-400 font-mono bg-gray-100 px-1.5 py-0.5 rounded font-medium flex-shrink-0'>
          {formatItemIndex(index, currentPage, itemsPerPage)}
        </span>
        <span
            className='text-sm text-gray-900 font-medium truncate'
            title={jobTitle.label}
        >
          {jobTitle.label}
        </span>
      </div>
      <button
          onClick={() => onDelete(jobTitle)}
          className='opacity-0 group-hover:opacity-100 text-gray-400 hover:text-red-600 hover:bg-red-50 p-1 rounded-md transition-all shrink-0'
          title='Delete'
          aria-label={`Delete job title ${jobTitle.label}`}
      >
        <SubtractCircleIcons className='w-4 h-4' />
      </button>
    </div>
  );
};
